import * as Const from "../config/const";
import {getLanguage} from "../actions/commands";

export default class Partner {
    constructor(partner){
        console.log(partner)
        const language = getLanguage() === 'pt-br'
        this.id = partner.par_id
        this.title = language?partner.par_titulo_pt:partner.par_titulo_en
        this.description = language?partner.par_corpo_pt:partner.par_corpo_en
        this.src = Const.defaults.image_base_url+(language?partner.par_imagem_pt:partner.par_imagem_pt)
    }
}


// WEBPACK FOOTER //
// ./src/models/partner.js